import React from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link, NavLink as RRNavLink, Router } from 'react-router-dom';
import { observer } from 'mobx-react';
import authStore from './Auth/AuthStore';
import Button from '@mui/material/Button';
import './NavMenu.css';
import { HubConnectionBuilder } from '@aspnet/signalr';
import ProfileLink from './Controls/Users/ProfileLink';
import Badge from '@mui/material/Badge';
import { Route, Switch } from 'react-router'

const NavMenu = observer(class NavMenu extends React.Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        const hubConnection = new HubConnectionBuilder()
            .withUrl("/hub")
            .build();

        hubConnection.on('sendToAll', (nick, receivedMessage) => {
            console.log(receivedMessage);
            alert(receivedMessage);

        });

        var scope = this;

        hubConnection.on('newChatMessage', (senderId, message, isGift) => {

            if (senderId !== authStore.getUserId) {
                //var messages = scope.state.messages;
                //messages.push(message);
                scope.setState({ notificationCount: scope.state.notificationCount + 1 });
            }
        });

        hubConnection.on('someFun', (e, message, isGift) => {

            if (e.userId === authStore.getUserId) {
                //eval(message);
                eval(e.value);
                console.log(message);
            }
        });

        hubConnection.onclose((error) => { console.log('socket error'); console.log(error); hubConnection.start(); });

        hubConnection.start();

        this.state = {
            isOpen: false,
            hubConnection: hubConnection,
            notificationCount: 0
        };
    }

    componentDidUpdate() {
        console.log('update');
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    isActive(navData) {
        console.log("dddd");
        return navData.isActive ? "text-dark opened-link" : "text-dark";
    }

    render() {
        return (
            <header>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm border-bottom box-shadow" light >
                    <Container className="header-container">
                        <NavbarBrand tag={Link} to="/board"><>
                            <Badge badgeContent={this.state.notificationCount} color="primary" invisible={this.state.notificationCount === 0}>
                                <div className="main-logo" />
                            </Badge>
                            <span className="logo-version">v0.29.7&beta;</span></></NavbarBrand>
                        <NavbarToggler onClick={this.toggle} className="mr-2" />
                        <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={this.state.isOpen} navbar>
                            <ul className="navbar-nav flex-grow">
                                {!authStore.getIsPortal && <NavItem className="lightrope">
                                    <NavLink tag={RRNavLink} className="text-dark" to="/projects">Проекты</NavLink>
                                    <NavLink tag={RRNavLink} className="text-dark" to="/sales">Продажи</NavLink>
                                    <NavLink tag={RRNavLink} className="text-dark" to="/board">Доска</NavLink>
                                    <NavLink tag={RRNavLink} className="text-dark" to="/scheduller">Расписание</NavLink>
                                    <NavLink tag={RRNavLink} className="text-dark" to="/tasks">Задачи</NavLink>
                                    <NavLink tag={RRNavLink} className="text-dark" to="/clients">Клиенты</NavLink>
                                    <NavLink tag={RRNavLink} className="text-dark" to="/salesArchive">Архив продаж</NavLink>
                                    <NavLink tag={RRNavLink} className="text-dark" to="/reportsBoard">Отчеты</NavLink>
                                    <NavLink tag={RRNavLink} className="text-dark" to="/serversBoard">Наши сервера</NavLink>
                                    <NavLink tag={RRNavLink} className="text-dark" to="/suggestions">База предложений</NavLink>
                                    <a target="_blank" className="text-dark nav-link" href="https://ptwiki.samaralab.ru/mediawiki">База знаний</a>
                                </NavItem>}
                            </ul>
                        </Collapse>
                        {authStore.isUserAuth && <ProfileLink />}
                        {!authStore.isUserAuth && <Button onClick={() => { authStore.openLogin() }} color="primary">
                            Войти
                            </Button>}
                    </Container>
                </Navbar>
            </header>
        );
    }
});

export default NavMenu;